
import Vue from 'vue';
import { mapState } from 'vuex';
import BackButton from '@/components/base/BackButton.vue';
import RegularSessionsDashboard from '@/views/Admin/AdminSessionsDashboard/RegularSessionsDashboard.vue';
import { ROUTER } from '@/router/constants';

export default Vue.extend({
	name: 'AdminSessionsDashboard',
	metaInfo: {
		title: 'Sessions Dashboard | Admin | RunDiffusion',
	},
	computed: {
		...mapState([
			'user',
		]),
	},
	methods: {
		goBack () {
			if (window.history.length > 2) {
				this.$router.back();
			} else {
				const hasCurrentSessionId: boolean = !!(this._get(this.toolbar, 'session.id'));

				if (hasCurrentSessionId) {
					this.routerPush(this.$route, this.$router, { name: ROUTER.LAUNCH, params: { sessionId: this._get(this.toolbar, 'session.id') } });
				} else {
					this.routerPush(this.$route, this.$router, { name: ROUTER.SESSIONS });
				}
			}
		},
	},
	components: {
		RegularSessionsDashboard,
		BackButton,
	},
});
